import {
    ensureGaugeNeedleIds,
    materializeLegacyGaugeNeedle,
} from '../../Hasp/gaugeNeedles.js'

/** Return the rows shown by the editor without changing a legacy node. */
export function getGaugeNeedleEditorRows(node, fallbackColor) {
    if (Array.isArray(node?.needles)) {
        ensureGaugeNeedleIds(node.needles)
        return node.needles
    }
    return [{ val: Number(node?.val), color: fallbackColor }]
}

export function addGaugeNeedle(node, fallbackColor) {
    const needles = Array.isArray(node?.needles)
        ? node.needles
        : materializeLegacyGaugeNeedle(node, fallbackColor)
    needles.push({ val: Number(node?.min) || 0, color: fallbackColor })
    ensureGaugeNeedleIds(needles)
    return needles
}
